import { CheckCircle2 } from "lucide-react";

export const Pill = ({ active, onClick, children, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-pressed={active}
    className={`inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
      active
        ? "border-blue-600 bg-blue-50 text-blue-700"
        : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
    }`}
  >
    {active && <CheckCircle2 className="mr-1.5 h-3.5 w-3.5" />} {children}
  </button>
);
